import React, { useState } from "react";
// MATERIAL ---------------------------------------------------------------->
import { Grid, TextField, Link, Typography, Button } from "@material-ui/core";
// <---------------------------------------------------------------- MATERIAL

// FORMIK ---------------------------------------------------------------->
import * as Yup from "yup";
import { useFormik } from "formik";
// <---------------------------------------------------------------- FORMIK
// SERVICES ---------------------------------------------------------------->
import { toast } from "react-toastify";
import { auth } from "../../../firebase";
import authentication from "../../../services/authentication";

// <---------------------------------------------------------------- SERVICES

export default function RecoverPassword(props) {
  const { classes, changeForm } = props;
  const [message, setMessage] = useState(false);

  const formik = useFormik({
    initialValues: {
      email: "",
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .email("El correo electronico es invalido")
        .required("El email es obligatorio"),
    }),
    onSubmit: async (formData) => {
      try {
        auth
          .sendPasswordResetEmail(formData.email)
          .then(() => {
            setMessage(true);
          })
          .catch((error) => {
            const errorCode = error.code;
            toast.error(authentication.verifyErrorCode(errorCode));
            console.log(error);
          });
      } catch (error) {
        toast.error(error);
        console.log(error);
      }
    },
  });

  if (message) {
    return (
      <Typography variant="h6" style={{ marginTop: "20px" }}>
        Hemos enviado los pasos para recuperar contraseña, revisa tu correo
        electronico.
      </Typography>
    );
  }

  return (
    <form
      noValidate
      autoComplete="off"
      onSubmit={formik.handleSubmit}
      className={classes.form}
    >
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            size="small"
            variant="outlined"
            required
            fullWidth
            id="email"
            label="Email"
            name="email"
            autoComplete="email"
            autoFocus
            value={formik.values.email}
            onChange={formik.handleChange}
            error={
              formik.errors.email === undefined ||
              formik.touched.email === undefined
                ? false
                : true
            }
            helperText={
              formik.errors.email && formik.touched.email
                ? formik.errors.email
                : null
            }
          />
        </Grid>
      </Grid>
      <Button
        type="submit"
        fullWidth
        variant="contained"
        color="primary"
        className={classes.submit}
      >
        Recuperar contraseña
      </Button>
      <Grid
        container
        direction="row"
        justifycontent="space-between"
        alignItems="center"
      >
        <Grid item xs={6}></Grid>
        <Grid item xs={6} style={{ textAlign: "right" }}>
          <Link href="#" variant="body2" onClick={() => changeForm(0)}>
            ¿Ya tienes una cuenta? Inicia sesión
          </Link>
        </Grid>
      </Grid>
    </form>
  );
}
